var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 11.2063C13.3322 11.2063 15.8882 12.3063 17.8224 14.1625C19.6875 16.0188 20.9309 18.4937 21 21.3125V22H20.3092H0.690789H0V21.3125C0.0690789 18.4937 1.3125 15.95 3.17763 14.1625C5.04276 12.3063 7.66776 11.2063 10.5 11.2063ZM10.5 0C13.3322 0 15.6809 2.26875 15.6809 5.15625C15.6809 7.975 13.3322 10.3125 10.5 10.3125C7.66776 10.3125 5.31908 8.04375 5.31908 5.15625C5.31908 2.3375 7.59868 0 10.5 0Z",
    fill: "#323429"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTEwLjUgMTEuMjA2M0MxMy4zMzIyIDExLjIwNjMgMTUuODg4MiAxMi4zMDYzIDE3LjgyMjQgMTQuMTYyNUMxOS42ODc1IDE2LjAxODggMjAuOTMwOSAxOC40OTM3IDIxIDIxLjMxMjVWMjJIMjAuMzA5MkgwLjY5MDc4OUgwVjIxLjMxMjVDMC4wNjkwNzg5IDE4LjQ5MzcgMS4zMTI1IDE1Ljk1IDMuMTc3NjMgMTQuMTYyNUM1LjA0Mjc2IDEyLjMwNjMgNy42Njc3NiAxMS4yMDYzIDEwLjUgMTEuMjA2M1pNMTAuNSAwQzEzLjMzMjIgMCAxNS42ODA5IDIuMjY4NzUgMTUuNjgwOSA1LjE1NjI1QzE1LjY4MDkgNy45NzUgMTMuMzMyMiAxMC4zMTI1IDEwLjUgMTAuMzEyNUM3LjY2Nzc2IDEwLjMxMjUgNS4zMTkwOCA4LjA0Mzc1IDUuMzE5MDggNS4xNTYyNUM1LjMxOTA4IDIuMzM3NSA3LjU5ODY4IDAgMTAuNSAwWiIgZmlsbD0iIzMyMzQyOSIvPgo8L3N2Zz4K";